import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ActivityIcon } from 'lucide-react';
import { useApplyModal } from './ApplyModalContext';
import { Link } from 'react-router-dom';
export function Navbar() {
  const {
    open
  } = useApplyModal();
  return <motion.header initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 bg-navy-950/80 backdrop-blur-md border-b border-white/5" data-id="element-113">
      <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity" data-id="element-114">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-electric to-mint flex items-center justify-center" data-id="element-115">
          <ActivityIcon className="w-5 h-5 text-navy-950" data-id="element-116" />
        </div>
        <span className="text-white font-semibold tracking-tight text-lg" data-id="element-117">
          Pulsewave
        </span>
      </Link>
      <nav data-id="element-118">
        <Button variant="primary" onClick={open} className="hidden sm:inline-flex py-2 px-4 text-sm" data-id="element-119">
          Apply to the Creator Lab
        </Button>
      </nav>
    </motion.header>;
}